import { Helmet } from 'react-helmet-async';

const defaults = {
  siteName: 'Elijah Moreno',
  siteUrl: 'https://elijahmoreno.com',
  image: 'https://elijahmoreno.com/icon-512.png',
  imageWidth: 512,
  imageHeight: 512,
  description: 'Personal academic website for Elijah Moreno, an Indigenous social scientist studying governance, institutions, and economic life.',
};

export default function SEO({
  title,
  description,
  path = '/',
  image,
  imageWidth,
  imageHeight,
  ogType,
  articleMeta,
  jsonLd,
}) {
  const pageTitle = title
    ? `${title} | ${defaults.siteName}`
    : `${defaults.siteName} | Indigenous Social Scientist`;
  const pageDescription = description || defaults.description;
  const canonicalUrl = `${defaults.siteUrl}${path}`;
  const pageImage = image || defaults.image;
  const imgWidth = imageWidth || defaults.imageWidth;
  const imgHeight = imageHeight || defaults.imageHeight;

  const breadcrumbLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: defaults.siteUrl },
      ...(title
        ? [{ '@type': 'ListItem', position: 2, name: title, item: canonicalUrl }]
        : []),
    ],
  };

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={ogType || 'website'} />
      <meta property="og:site_name" content={defaults.siteName} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:image:width" content={String(imgWidth)} />
      <meta property="og:image:height" content={String(imgHeight)} />

      {articleMeta && <meta property="article:author" content={articleMeta.author} />}
      {articleMeta && <meta property="article:published_time" content={articleMeta.publishedTime} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />

      <script type="application/ld+json">{JSON.stringify(breadcrumbLd)}</script>
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
